module.exports = __webpack_public_path__ + "img/Female_user_help.4559a853.png";